import React from 'react';

export const WhichBotLogo = ({ size = 40, style, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={size}
      height={size}
      style={{ display: 'block', ...style }}
      {...props}
    >
      <defs>
        {/* The shape of the Question Mark */}
        <path
          id="q-mark-path"
          d="M384,160 c45,0 80,30 80,75 c0,24 -15,42 -34,54 c-18,12 -22,18 -22,35 v10 h-56 v-14 c0,-30 16,-45 40,-58 c16,-8 18,-16 18,-27 c0,-16 -12,-28 -32,-28 c-22,0 -34,14 -36,34 h-56 c2,-45 38,-81 98,-81 z M358,365 h56 v56 h-56 z"
        />
        
        {/* 
           The Mask: 
           1. Fills everything with White (Visible)
           2. Draws the Question Mark with a thick Black stroke (Hidden/Cutout)
        */}
        <mask id="cut-overlap">
          <rect width="100%" height="100%" fill="white" />
          <use href="#q-mark-path" stroke="black" strokeWidth="50" fill="black" />
        </mask>
      </defs>

      {/* 
         ROBOT GROUP 
         Offset to the Top-Left
         Applied mask cuts the bottom-right corner where the ? sits
      */}
      <g mask="url(#cut-overlap)" fill="currentColor">
         {/* Head */}
         <rect x="48" y="96" width="320" height="280" rx="48" />
         {/* Ears */}
         <rect x="16" y="186" width="32" height="100" rx="8" />
         {/* Antenna */}
         <rect x="188" y="32" width="40" height="64" />
         <circle cx="208" cy="32" r="24" />
      </g>

      {/* 
         QUESTION MARK
         Drawn in solid color on top (Bottom-Right)
      */}
      <use href="#q-mark-path" fill="currentColor" />
    </svg>
  );
};